import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Dashboard from './containers/Dashboard/Dashboard';
import EntityListing from './containers/EntityListing/EntityListing';
import VerifySources from './containers/VerifySources/VerifySources';
import CrawlerConfig from './containers/CrawlerConfig/CrawlerConfig';
import UrlFinderStatus from './containers/UrlFinderStatus/UrlFinderStatus';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />

        <Switch>
          <Route exact path="/">
            <Dashboard />
          </Route>
          <Route path="/entity-listing">
            <EntityListing />
          </Route>
          <Route path="/verify-sources/:entityId">
            <VerifySources />
          </Route>
          <Route path="/crawler-config">
            <CrawlerConfig />
          </Route>
          <Route path="/url-finder">
            <UrlFinderStatus />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
